import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-interaction-search-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfInteractionSearchIconProps extends SvgIconProps {
  fillColor?: any;
}

/**
 * Component displays Instagram Icon
 * @param props -CcfInstaIconProps
 * @returns instagram svg icon
 * @example <CcfInstIcon/>
 */
export function CcfInteractionSearchIcon(props: CcfInteractionSearchIconProps) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="-2 -2 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_10171_896)">
        <path
          d="M1 7.4C1 10.92 3.88 13.8 7.4 13.8C8.84 13.8 10.2 13.32 11.32 12.44L15.64 16.76C15.96 17.08 16.44 17.08 16.76 16.76C17.08 16.44 17.08 15.96 16.76 15.64L12.44 11.32C13.32 10.2 13.8 8.84 13.8 7.4C13.8 3.88 10.92 1 7.4 1C3.88 1 1 3.88 1 7.4ZM2.6 7.4C2.6 4.76 4.76 2.6 7.4 2.6C10.04 2.6 12.2 4.76 12.2 7.4C12.2 10.04 10.04 12.2 7.4 12.2C4.76 12.2 2.6 10.04 2.6 7.4Z"
          fill="#333333"
          stroke="#333333"
          stroke-width="0.6"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_10171_896">
          <rect width="18" height="18" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
}

export default CcfInteractionSearchIcon;
